// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Gabon from '../_raw/flag/icon_flag_gabon.png';

export default () => <img src={Gabon} alt="Gabon" />;
